module.exports = __webpack_public_path__ + "img/img_userCase1.72bee021.png";